'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DateTimePickerDays = function (_Component) {
  _inherits(DateTimePickerDays, _Component);

  function DateTimePickerDays(props) {
    _classCallCheck(this, DateTimePickerDays);

    var _this = _possibleConstructorReturn(this, (DateTimePickerDays.__proto__ || Object.getPrototypeOf(DateTimePickerDays)).call(this, props));

    _this.renderDays = _this.renderDays.bind(_this);
    _this.renderDay = _this.renderDay.bind(_this);
    _this.renderFooter = _this.renderFooter.bind(_this);
    _this.updateSelectedDate = _this.updateSelectedDate.bind(_this);

    _this.state = {};
    return _this;
  }

  _createClass(DateTimePickerDays, [{
    key: 'getDaysOfWeek',
    value: function getDaysOfWeek(locale) {
      var days = locale._weekdaysMin;

      var first = locale.firstDayOfWeek();

      var dow = [];

      var i = 0;
      days.forEach(function (day) {
        dow[(7 + i++ - first) % 7] = day;
      });

      return dow;
    }
  }, {
    key: 'updateSelectedDate',
    value: function updateSelectedDate(event) {
      this.props.updateSelectedDate(event, true);
    }
  }, {
    key: 'renderDays',
    value: function renderDays() {
      var date = this.props.viewDate;
      var selected = this.props.selectedDate && this.props.selectedDate.clone();
      var prevMonth = date.clone().subtract(1, 'months');
      var currentYear = date.year();
      var currentMonth = date.month();
      var weeks = [];
      var days = [];
      var renderer = this.props.renderDay || this.renderDay;
      var isValid = this.props.isValidDate || function () {
        return 1;
      };
      var classes = void 0;
      var isDisabled = void 0;
      var dayProps = void 0;
      var currentDate = void 0;

      prevMonth.date(prevMonth.daysInMonth()).startOf('week');
      var lastDay = prevMonth.clone().add(42, 'd');

      while (prevMonth.isBefore(lastDay)) {
        classes = 'rdtDay';
        currentDate = prevMonth.clone();

        if (prevMonth.year() === currentYear && prevMonth.month() < currentMonth || prevMonth.year() < currentYear) {
          classes += ' rdtOld';
        } else if (prevMonth.year() === currentYear && prevMonth.month() > currentMonth || prevMonth.year() > currentYear) {
          classes += ' rdtNew';
        }

        if (selected && prevMonth.isSame(selected, 'day')) {
          classes += ' rdtActive';
        }

        if (this.props.rangeMode) {
          if (this.props.selectedDateEnd && prevMonth.isBetween(selected, this.props.selectedDateEnd, 'day')) {
            classes += ' rdtActive';
          } else if (selected && this.state.temporaryDateEnd && prevMonth.isBetween(selected, this.state.temporaryDateEnd, 'day')) {
            classes += ' rdtDayHovered';
          }

          if (this.props.selectedDateEnd && prevMonth.isSame(this.props.selectedDateEnd, 'day')) {
            classes += ' rdtActive';
          }
        }

        if (prevMonth.isSame((0, _moment2.default)(), 'day')) {
          classes += ' rdtToday';
        }

        isDisabled = !isValid(currentDate, selected);
        if (isDisabled) {
          classes += ' rdtDisabled';
        }

        dayProps = {
          key: prevMonth.format('M_D'),
          'data-value': prevMonth.date(),
          className: classes
        };

        if (!isDisabled) {
          dayProps.onClick = this.updateSelectedDate;
        }

        days.push(renderer(dayProps, currentDate, selected));

        if (days.length === 7) {
          weeks.push(_jsx('tr', {}, prevMonth.format('M_D'), days));
          days = [];
        }

        prevMonth.add(1, 'd');
      }

      return weeks;
    }
  }, {
    key: 'renderDay',
    value: function renderDay(props, currentDate) {
      var _this2 = this;

      return _react2.default.createElement(
        'td',
        _extends({}, props, {
          onMouseEnter: function onMouseEnter() {
            if (_this2.props.rangeMode) _this2.setState({ temporaryDateEnd: currentDate });
          },
          onMouseLeave: function onMouseLeave() {
            if (_this2.props.rangeMode) _this2.setState({ temporaryDateEnd: null });
          }
        }),
        currentDate.date()
      );
    }
  }, {
    key: 'renderFooter',
    value: function renderFooter() {
      if (!this.props.timeFormat) {
        return '';
      }

      var date = this.props.selectedDate || this.props.viewDate;

      return _jsx('tfoot', {}, 'tf', _jsx('tr', {}, void 0, this.props.todayButton && _jsx('td', {
        role: 'presentation',
        onClick: this.props.setToToday,
        className: 'rdtTodayButton',
        colSpan: '2'
      }, void 0, 'Today'), _jsx('td', {
        role: 'presentation',
        onClick: this.props.showView('time'),
        className: 'rdtTimeToggle',
        colSpan: this.props.todayButton ? '5' : '7'
      }, void 0, date.format(this.props.timeFormat))));
    }
  }, {
    key: 'render',
    value: function render() {
      var date = this.props.viewDate;
      var locale = date.localeData();

      return _jsx('div', {
        className: 'rdtDays'
      }, void 0, _jsx('table', {}, void 0, _jsx('thead', {}, void 0, _jsx('tr', {}, void 0, _jsx('th', {
        className: 'rdtPrev'
      }, void 0, _jsx('span', {
        role: 'presentation',
        onClick: this.props.subtractTime(1, 'months')
      }, void 0, '\u2039')), _jsx('th', {
        className: 'rdtSwitch',
        onClick: this.props.showView('months'),
        colSpan: '5',
        'data-value': this.props.viewDate.month()
      }, void 0, locale.months(date) + ' ' + date.year()), _jsx('th', {
        className: 'rdtNext'
      }, void 0, _jsx('span', {
        role: 'presentation',
        onClick: this.props.addTime(1, 'months')
      }, void 0, '\u203A'))), _jsx('tr', {}, void 0, this.getDaysOfWeek(locale).map(function (day, index) {
        return _jsx('th', {
          className: 'dow'
        }, date + index, day);
      }))), _jsx('tbody', {}, void 0, this.renderDays()), !this.props.rangeMode && this.props.timePicker && this.renderFooter()));
    }
  }]);

  return DateTimePickerDays;
}(_react.Component);

DateTimePickerDays.propTypes = {
  updateSelectedDate: _propTypes2.default.func.isRequired,
  timeFormat: _propTypes2.default.string,
  showView: _propTypes2.default.func.isRequired,
  subtractTime: _propTypes2.default.func.isRequired,
  addTime: _propTypes2.default.func.isRequired
};
exports.default = DateTimePickerDays;